<template>
  <div>
    <div class="banner" id="banner">
      <div class="banner-container"></div>
    </div>
    <div ref="portus" class="banner_box_media">
      <div class="banner_center_media">
        <div class="portus_title fz46">
          {{ $t("solution.portus") }}
        </div>

        <div class="portus_solution">
          <div class="portus_left_widthHeight">
            <img
              src="../../public/static/img/solution/portus_left.png"
              alt=""
            />
          </div>
          <div class="right_explain ml128">
            <div class="explain_title">{{ $t("solution.marketing") }}</div>
            <div class="explain_content" style="margin-bottom: 39px">
              {{ $t("solution.marketing_") }}
            </div>
            <div class="learnMore" @click="$router.push('portus')">
              {{ $t("media.more") }}
              <div class="goLearnMore">
                <img
                  style="margin-top: -13px"
                  src="../../public/static/img/home/learnMore.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="banner_box_media" style="background-color: #f5f5f5">
      <div class="banner_center_media">
        <div class="portus_title fz36">
          {{ $t("solution.experience") }}
        </div>

        <div
          class="img_center"
          style="margin: auto; margin-bottom: 100px"
          :style="{
            width: $t('solution.solution_img_width'),
            height: $t('solution.solution_img_height'),
          }"
        >
          <img
            style="width: 100%; height: 100%"
            :src="$t('picture.disadvantage')"
            alt=""
          />
        </div>

        <div class="portus_solution">
          <div class="right_explain mr100">
            <div class="explain_title">{{ $t("solution.integrated") }}</div>
            <div class="explain_content">
              {{ $t("solution.integrated_") }}
            </div>
          </div>
          <div class="portus_right_widthHeight">
            <img
              src="../../public/static/img/solution/portus_right.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="banner_box_media">
      <div class="banner_center_media">
        <div style="width: 100%; height: 36vw">
          <img
            style="width: 100%; height: 100%"
            :src="$t('picture.advantage')"
            alt=""
          />
        </div>
      </div>
    </div>

    <div
      ref="portusAir"
      class="banner_box_media"
      style="background-color: #f5f5f5"
    >
      <div class="banner_center_media">
        <div class="portus_title fz46">
          {{ $t("solution.portusAir") }}
        </div>

        <div class="portusAir_solution portusAir_solution_height">
          <div class="portusAir_title">{{ $t("solution.suffer") }}</div>
          <div class="portusAir_pic">
            <div class="portusAir_pic_box">
              <div class="portusAir_img">
                <img src="../../public/static/img/solution/kind.png" alt="" />
              </div>

              <div class="position_explain">
                <div class="portusAir_explain">
                  {{ $t("solution.suffer1") }}
                </div>
                <div class="portusAir_explain">
                  {{ $t("solution.suffer1_") }}
                </div>
              </div>
            </div>
            <div class="portusAir_pic_box">
              <div class="portusAir_img">
                <img src="../../public/static/img/solution/ge.png" alt="" />
              </div>
              <div class="position_explain">
                <div class="portusAir_explain">
                  {{ $t("solution.suffer2") }}
                </div>
                <div class="portusAir_explain">
                  {{ $t("solution.suffer2_") }}
                </div>
              </div>
            </div>
            <div class="portusAir_pic_box">
              <div class="portusAir_img">
                <img src="../../public/static/img/solution/xiao.png" alt="" />
              </div>
              <div class="position_explain">
                <div class="portusAir_explain">
                  {{ $t("solution.suffer3") }}
                </div>
                <div class="portusAir_explain">
                  {{ $t("solution.suffer3_") }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="portus_solution p129">
          <div class="right_explain mr144">
            <div class="explain_title fontsize26">
              {{ $t("solution.realize") }}
            </div>
            <div class="explain_content pl4">
              <div class="triangle_explain">
                <div class="triangle mt15"></div>
                <div>
                  {{ $t("solution.realize1") }}
                </div>
              </div>
              <div class="triangle_explain">
                <div class="triangle mt15"></div>
                <div>{{ $t("solution.realize2") }}</div>
              </div>
              <div class="triangle_explain">
                <div class="triangle mt15"></div>
                <div>
                  {{ $t("solution.realize3") }}
                </div>
              </div>
              <div class="triangle_explain" style="margin-bottom: 79px">
                <div class="triangle mt15"></div>
                <div>{{ $t("solution.realize4") }}</div>
              </div>
              <div
                class="learnMore"
                style="color: #333"
                @click="$router.push('portus-air')"
              >
                {{ $t("media.more") }}
                <div class="goLearnMore">
                  <img
                    style="margin-top: -13px"
                    src="../../public/static/img/home/learnMore.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="special_ticket_widthHeight">
            <img
              src="../../public/static/img/solution/special_ticket.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div ref="portusFin" class="banner_box_media">
      <div class="banner_center_media">
        <div class="little_title">{{ $t("solution.portusFin") }}</div>
        <div class="little_explain">
          {{ $t("solution.portusFin_") }}
        </div>

        <div class="portusAir_pic mb147">
          <div class="portusFin_pic_box">
            <img
              class="portusAir_img mb30"
              src="../../public/static/img/solution/fu.png"
              alt=""
            />
            <div class="portusFin_width mb19">
              {{ $t("solution.service") }}
            </div>
            <div class="portusFin_explain">
              {{ $t("solution.service_") }}
            </div>
          </div>
          <div class="portusFin_pic_box">
            <img
              class="portusAir_img mb30"
              src="../../public/static/img/solution/jie.png"
              alt=""
            />
            <div class="portusFin_width mb19">
              {{ $t("solution.way") }}
            </div>
            <div class="portusFin_explain">
              {{ $t("solution.way_") }}
            </div>
          </div>
          <div class="portusFin_pic_box">
            <img
              class="portusAir_img mb30"
              src="../../public/static/img/solution/shu.png"
              alt=""
            />
            <div class="portusFin_width mb19">
              {{ $t("solution.uniqueness") }}
            </div>
            <div class="portusFin_explain">
              {{ $t("solution.uniqueness_") }}
            </div>
          </div>
        </div>

        <div class="portus_solution mb72">
          <div class="right_explain mr177">
            <div class="explain_title fz34">
              {{ $t("solution.coop") }}
            </div>
            <div class="explain_content pl4">
              <div class="coop_explain">
                <div class="solution1">
                  <img src="../../public/static/img/solution/1.png" alt="" />
                </div>
                <div class="ml20">
                  {{ $t("solution.coop1") }}
                </div>
              </div>
              <div class="coop_explain">
                <div class="solution2">
                  <img src="../../public/static/img/solution/2.png" alt="" />
                </div>
                <div class="ml20">
                  {{ $t("solution.coop2") }}
                </div>
              </div>
              <div class="coop_explain">
                <div class="solution3 pt8">
                  <img src="../../public/static/img/solution/3.png" alt="" />
                </div>
                <div class="ml20">
                  {{ $t("solution.coop3") }}
                </div>
              </div>
              <div class="coop_explain">
                <div class="solution4">
                  <img src="../../public/static/img/solution/4.png" alt="" />
                </div>
                <div class="ml20">
                  {{ $t("solution.coop4") }}
                </div>
              </div>
              <div class="coop_explain">
                <div class="solution5">
                  <img src="../../public/static/img/solution/5.png" alt="" />
                </div>
                <div class="ml20">
                  {{ $t("solution.coop5") }}
                </div>
              </div>
            </div>
          </div>
          <div class="coop_travel_widthHeight">
            <img
              src="../../public/static/img/solution/coop_travel.png"
              alt=""
            />
          </div>
        </div>
        <div class="goRecruit" @click="$router.push('recruit')">
          {{ $t("solution.recruit") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  methods: {},
  mounted () {
    console.log('携带参数：', this.$route.query.type)
    if (this.$route.query.type === 'portus') {
      this.$nextTick(() => {
        window.scrollTo(0, this.$refs.portus.offsetTop);
      })
    } else if (this.$route.query.type === 'portusAir') {
      this.$nextTick(() => {
        window.scrollTo(0, this.$refs.portusAir.offsetTop);
      })
    } else if (this.$route.query.type === 'portusFin') {
      this.$nextTick(() => {
        window.scrollTo(0, this.$refs.portusFin.offsetTop);
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.clear {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.banner .banner-container {
  padding-top: 86px;
  min-height: 638px;
  background-image: url("http://travelmall.portus.cn/2023/05/93068dc64f0347ad8a6a10ccb8fbc94b.png");
  background-repeat: no-repeat center;
  background-size: 100% 100%;
}
</style>
